import { createReducer } from "@reduxjs/toolkit";
const initialState = {
    isLoading: false,
    isLoadingCase: false,
  };

  const casesReducer = createReducer(initialState, (builder) => {
    builder
    
      .addCase("get_Fillter_cases_request", (state) => {
        state.isLoading = true;
      })
      .addCase("get_Fillter_cases_success", (state,action) => {
        state.isLoading = false;
        state.FillterCases = action.payload.cases;
        state.paginationCase = action.payload.pagination;
      })
      .addCase("get_Fillter_cases_error", (state,action) => {
        state.isLoading = false;
        state.err = action.payload;
      })
      .addCase("get_User_cases_request", (state) => {
        state.isLoading = true;
      })
      .addCase("get_User_cases_success", (state,action) => {
        state.isLoading = false;
        state.UserCases = action.payload.cases;
        state.paginationCase = action.payload.pagination;
      })
      .addCase("get_User_cases_error", (state,action) => {
        state.isLoading = false;
        state.err = action.payload;
      })
      .addCase("get_case_request", (state) => {
        state.isLoadingCase = true;
      })
      .addCase("get_case_success", (state,action) => {
        state.isLoadingCase = false;
        state.caseData = action.payload;
      })
      .addCase("get_case_error", (state,action) => {
        state.isLoadingCase = false;
        state.err = action.payload;
      });
  });
  
  export default casesReducer;